import React, { useEffect, useState } from "react";
import { paymentAPI } from "../../../services/paymentAPI";
import styles from './order.module.css';
import { getUserIdFromToken } from '../../../utils/auth';

function OrderPage() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const id = getUserIdFromToken();
        setUserId(id);

        const onStorage = () => setUserId(getUserIdFromToken());
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    useEffect(() => {
        if (userId) loadOrders();
    }, [userId]);

    const loadOrders = async () => {
        setLoading(true);
        try {
            const response = await paymentAPI.get_user_orders(userId);
            const data = response.data || response;
            setOrders(data);
        } catch (error) {
            console.error("Erro ao carregar pedidos:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = async (orderId) => {
        if (!window.confirm("Tem certeza que deseja cancelar este pedido e liberar o estoque?")) return;
        if (!userId) return alert('Faça login para cancelar pedidos.');

        try {
            await paymentAPI.cancel_order(orderId, userId);
            setOrders(prevOrders => 
                prevOrders.map(order => 
                    order.order_id === orderId ? { ...order, status: 'canceled' } : order
                )
            );
            alert("Pedido cancelado com sucesso!");
        } catch (error) {
            console.error("Erro ao cancelar:", error);
            alert("Não foi possível cancelar o pedido.");
        }
    };

    if (!userId) return <div className={styles.loading}>Faça login para ver seus pedidos.</div>;
    if (loading) return <div className={styles.loading}>Buscando seus pedidos...</div>;

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Meus Pedidos<span>.</span></h1>
            
            {orders.length === 0 ? (
                <div className={styles.empty}>
                    <p>Você ainda não tem nenhum pedido registrado.</p>
                </div>
            ) : (
                <div className={styles.grid}>
                    {orders.map((order) => (
                        <div key={order.order_id} className={styles.orderCard}>
                            <div className={styles.header}>
                                <div>
                                    <span className={styles.orderNumber}>#ID: {order.order_id}</span>
                                    <p className={styles.date}>{new Date(order.date).toLocaleDateString('pt-BR')}</p>
                                </div>
                                <span className={styles.status} data-status={order.status}>
                                    {order.status === 'pending' ? 'Aguardando Pagamento' : 
                                     order.status === 'paid' ? 'Pago' : 
                                     order.status === 'canceled' ? 'Cancelado' : order.status}
                                </span>
                            </div>

                            <div className={styles.content}>
                                <div className={styles.itemsList}>
                                    {order.items.map((item, idx) => (
                                        <div key={idx} className={styles.itemRow}>
                                            <span>{item.quantity}x {item.product_name}</span>
                                            <span>R$ {item.price.toFixed(2)}</span>
                                        </div>
                                    ))}
                                </div>
                                
                                <div className={styles.footer}>
                                    <div className={styles.totalArea}>
                                        <span>Total do Pedido</span>
                                        <strong>R$ {order.total.toFixed(2)}</strong>
                                    </div>

                                    {order.status === 'pending' && (
                                        <div className={styles.actionButtons}>
                                            <button 
                                                className={styles.cancelBtn}
                                                onClick={() => handleCancel(order.order_id)}
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default OrderPage;